import http from "./http";

export const getCurrentIssueApi = () => http.get("/api/player/issue/current");
export const getLastSettledApi = (limit = 20) =>
    http.get("/api/player/issue/last-settled", { params: { limit } });
